import ContactListBase from "./ContactListBase";


export default function EmployeeList() {
    return <ContactListBase title="Funcionários" endpoint="contacts/" defaultType="EMPLOYEE" />;
}